import { BaseService } from './utils/BaseService';
import type {
  CreateInvestorBody,
  CreateInvestorResponse,
  CreateInvestorReviewBody,
  CreateInvestorReviewResponse,
  EditInvestorBody,
  EditInvestorResponse,
  EditInvestorReviewBody,
  EditInvestorReviewResponse,
  ListInvestorReviewsQuery,
  ListInvestorReviewsResponse,
  ListInvestorsQuery,
  ListInvestorsResponse,
  RetrieveInvestorQuery,
  RetrieveInvestorResponse,
  RetrieveInvestorReviewResponse,
  DeleteInvestorReviewResponse,
} from '$shared/api';

export class InvestorService extends BaseService {
  retrieveInvestor(
    query: RetrieveInvestorQuery,
  ): Promise<RetrieveInvestorResponse> {
    return this.client.send('/api/investor', {
      method: 'GET',
      query,
    });
  }

  listInvestors(query?: ListInvestorsQuery): Promise<ListInvestorsResponse> {
    return this.client.send('/api/investors', {
      method: 'GET',
      query,
    });
  }

  createInvestor(body: CreateInvestorBody): Promise<CreateInvestorResponse> {
    return this.client.send('/api/investor', {
      method: 'POST',
      body,
    });
  }

  editInvestor(
    id: string,
    body: EditInvestorBody,
  ): Promise<EditInvestorResponse> {
    return this.client.send(`/api/investor/${id}`, {
      method: 'PUT',
      body,
    });
  }

  retrieveInvestorReview(id: string): Promise<RetrieveInvestorReviewResponse> {
    return this.client.send(`/api/investor/review/${id}`, {
      method: 'GET',
    });
  }

  listInvestorReviews(
    slug: string,
    query?: ListInvestorReviewsQuery,
  ): Promise<ListInvestorReviewsResponse> {
    return this.client.send(`/api/investor/${slug}/reviews`, {
      method: 'GET',
      query,
    });
  }

  createInvestorReview(
    body: CreateInvestorReviewBody,
  ): Promise<CreateInvestorReviewResponse> {
    return this.client.send('/api/investor/review', {
      method: 'POST',
      body,
    });
  }

  editInvestorReview(
    id: string,
    body: EditInvestorReviewBody,
  ): Promise<EditInvestorReviewResponse> {
    return this.client.send(`/api/investor/review/${id}`, {
      method: 'PUT',
      body,
    });
  }

  deleteInvestorReview(id: number): Promise<DeleteInvestorReviewResponse> {
    return this.client.send(`/api/investor/review/${id}`, {
      method: 'DELETE',
    });
  }
}
